// Journal entries that have no book (ticket 94).
//
// An entry the reader wrote about a book Reanlo doesn't have carries their own words
// for it in reflections.entry_title and has no book_id. Everything that shows an
// entry has to cope with that. These are the small decisions the journal, the public
// profile and their checks share, kept here so they can be run without a page.

// An entry is bookless when it has no book. The database makes sure it then has a title.
export const isBookless = (row) => row?.book_id == null;

// The books to look up for a list of entries. A bookless entry has no book, so it adds
// nothing: sending null to the lookup would fail it, and every entry on the page would
// lose its book with it.
export function bookIdsToLookUp(rows) {
  return [...new Set((rows || []).map((r) => r?.book_id).filter((id) => id != null))];
}

// Whether two entries are about the same book. A bookless entry is about no book, so it
// is only ever the same as itself: with no book to match on, matching on book_id would
// make every bookless entry one book.
export function sameBookEntry(a, b) {
  if (!a || !b) return false;
  if (a.id != null && a.id === b.id) return true;
  return a.book_id != null && a.book_id === b.book_id;
}

// ── The title a reader gives an entry about a book Reanlo doesn't have ─────────────
//
// Same rules as the database (reflections_title_length): up to 100 characters, counted
// as the database counts them (char_length, so an emoji is one, not JavaScript's two),
// and not blank. trim() strips spaces, tabs, line breaks and non-breaking spaces, so a
// title of only those is refused here before the database has to.
export const ENTRY_TITLE_MAX = 100;

export const entryTitleLength = (title) => [...String(title ?? '')].length;

// The title as it is saved.
export const cleanEntryTitle = (title) => String(title ?? '').trim();

// null when the title can be saved, otherwise why not.
export function entryTitleProblem(title) {
  const clean = cleanEntryTitle(title);
  if (!clean) return 'blank';
  if (entryTitleLength(clean) > ENTRY_TITLE_MAX) return 'too_long';
  return null;
}

// What the box keeps as it is typed: cut at 100 characters, never in the middle of an
// emoji (the input's own maxLength counts UTF-16 units and would).
export function limitEntryTitle(title) {
  const chars = [...String(title ?? '')];
  return chars.length > ENTRY_TITLE_MAX ? chars.slice(0, ENTRY_TITLE_MAX).join('') : chars.join('');
}
